import { handleTileClick } from '../../utils/tiles'
/**
 * A11y helper to trigger click on link element when user clicks anywhere
 * within tile element. Can be used anywhere by adding `js-tile` class to
 * outer card element and `js-tile-link` to the link to be triggered.
 */
const Tile = (function () {
  const initTiles = () => {
    const tileLinkEls = document.querySelectorAll('.js-tile')
    tileLinkEls.forEach((tileEl) => {
      tileEl.addEventListener('click', handleTileClick)
    })
  }

  const killTiles = () => {
    const tileLinkEls = document.querySelectorAll('.js-tile')
    tileLinkEls.forEach((tileEl) => {
      tileEl.removeEventListener('click', handleTileClick)
    })
  }

  return {
    init: () => {
      initTiles()
    },
    kill: () => {
      killTiles()
    },
  }
})()

export default Tile
